import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
export const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validar que las variables de entorno estén configuradas
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Error: Variables de entorno de Supabase no configuradas');
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl ? 'Configurado' : 'NO CONFIGURADO');
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Configurado' : 'NO CONFIGURADO');
}

export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;